<template>
  <generic-container
    :title="$t('course section')"
    icon="book"
    :header_buttons="header_buttons"
  >
    <h2 class="ui header">
      <i class="users icon"></i>
      <div class="content" v-if="section">
        {{ section.name }} <small>| {{ section.setup.schedule }}</small>
        <div
          class="sub header"
          v-if="
            section &&
              section.crs_assignation_season &&
              section.crs_assignation_season
          "
        >
          {{ section.crs_assignation_season.name }}
        </div>
      </div>
    </h2>
    <weighting ref="weighting" />
  </generic-container>
</template>

<script>
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import { local_api, error_toast, success_toast } from "@/utils";
import Weighting from "./Weighting";
// import Course from "./Course";

// @ is an alias to /src
export default {
  name: "CourseScoringEditIndex",
  components: {
    Weighting,
    GenericContainer, // Course,
  },
  filters: filters,
  data() {
    return {
      course: {},
      course_configuration: {},
      section: { setup: {} },
      header_buttons: [
        {
          icon: "refresh",
          tooltip: this.$t("refresh"),
          click: this.init,
        },
        {
          icon: "blue save",
          tooltip: this.$t("save"),
          click: this.save,
        },
      ],
    };
  },
  computed: {},
  methods: {
    init() {
      let vm = this;
      let section_uuid = this.$route.query.i;
      if (section_uuid) {
        local_api(vm, "post", "/course/section/do-get", {
          u: section_uuid,
        })
          .then((section) => {
            vm.section = section;
            vm.course = section.crs_course;

            if (section && section.setup && section.setup.weighting) {
              vm.$refs.weighting.setList(section.setup.weighting);
            } else if (
              vm.course &&
              vm.course.setup &&
              vm.course.setup.weighting
            ) {
              vm.$refs.weighting.setList(vm.course.setup.weighting);
            }
          })
          .catch((err) => {
            error_toast(err);
          });
      } else {
        error_toast(this.$t("no course section found"));
      }
    },
    save() {
      let vm = this;

      let weighting = vm.$refs.weighting.getList();
      local_api(vm, "post", "/course/section/do-save-configuration", {
        s: {
          weighting: weighting,
        },
        u: vm.section.uuid,
      })
        .then((/* assignation */) => {
          success_toast(vm.$t("section data saved"));
        })
        .catch((err) => {
          error_toast(err);
        });
    },
  },
  created() {},
  mounted() {
    let vm = this;
    vm.init();
  },
  watch: {},
};
</script>
